import * as ents from '@attain-apps/entities'
import { TypeChecker } from '@attain-apps/type-guards'

export interface Employee
  extends ents.core.common.Identified<Employee.Id>,
    ents.core.common.Named {}
export namespace Employee {
  export const isEmployee: TypeChecker<Employee> = TypeChecker.Factory.lazy(
    () =>
      TypeChecker.Factory.intersection(
        ents.core.common.Identified.getTypeChecker<Id>(Id.isId),
        ents.core.common.Named.isNamed,
      ),
  ).usingAlias('me.users.me.Employee')
  export type Id = string
  export namespace Id {
    export const isId: TypeChecker<Id> = TypeChecker.isString.usingAlias(
      'me.users.me.Employee.Id',
    )
  }
}
